if (!customElements.get('tabbed-details-with-image')) {
	class CustomTimeline extends HTMLElement {
		constructor() {
			super();
			this.id = this.dataset.id;
			this.tabsContainer = this.querySelector('.tabs');
			this.tabs = this.querySelectorAll('.tab');
			this.debounceTimeout = null;
		}
		connectedCallback() {
			for (const tab of this.tabs) {
				tab.addEventListener('click', () => {
					const tabNumber = tab.dataset.tab;
					const tabEls = this.querySelectorAll(`[data-tab]`);
					const currentTabEls = this.querySelectorAll(`[data-tab="${tabNumber}"]`);

					for (const el of tabEls) el.classList.remove('active');
					for (const el of currentTabEls) el.classList.add('active');

					this.centerTab(tab);
				});
			}

			this.tabsContainer.addEventListener('scroll', () => {
				clearTimeout(this.debounceTimeout);
				this.debounceTimeout = setTimeout(() => this.checkCentredItem(), 50);
			});
		}
		centerTab(tab) {
			const containerCenter = this.tabsContainer.offsetWidth / 2;
			const tabCenter = tab.offsetLeft + tab.offsetWidth / 2;

			this.tabsContainer.scrollTo({
				left: tabCenter - containerCenter,
				behavior: 'smooth'
			});
		}
		checkCentredItem() {
			const containerCenter = this.tabsContainer.scrollLeft + this.tabsContainer.offsetWidth / 2;

			this.tabs.forEach(tab => {
				const tabCenter = tab.offsetLeft + tab.offsetWidth / 2;

				if (Math.abs(containerCenter - tabCenter) < tab.offsetWidth / 2) {
					tab.click();
				}
			});
			
		}
	}
	customElements.define('tabbed-details-with-image', CustomTimeline);
}
